/* eslint no-control-regex: "off" */
/* eslint @typescript-eslint/no-this-alias: off */
/* eslint @typescript-eslint/no-unused-vars: off */
/* eslint @typescript-eslint/prefer-for-of: off */
/* eslint @typescript-eslint/restrict-plus-operands: off */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* global __G_OPTIONS__ */

'use strict';

import 'jquery-validation';

import type { BinaryOperationType, ComplexFilter, ComplexObject, ValueTypeDef } from '@comped/alchemy2-shared';
import type JQuery from 'jquery';
import sha1 from 'js-sha1';
import moment from 'moment';

import type {
    ApiOptions, TypedApiCall, TypedDbsCall,
} from '#public_ts/api';
import type {
    TypedCenturyCall,
} from '#public_ts/api/century';

import {
    WAITING_DLG_HTML,
} from './common-binary';

let _tabledata = null;

export const DISPLAY_WIDTHS = {
    xl: 1200,
    md: 992,
    sm: 576,
    user: screen.width,
};

$(window).on('resize', function() {
    DISPLAY_WIDTHS.user = screen.width;
});


let CHECKBOX_MULTISELECT = false;
export const LONGPRESS_DURATION = 250;

export function turnOffMultiSelect() {
    CHECKBOX_MULTISELECT = false;
    $('.multiselect-cancel').fadeOut('fast');
}
export function setMultiSelect(_CHECKBOX_MULTISELECT) {
    CHECKBOX_MULTISELECT = _CHECKBOX_MULTISELECT;
}
export function getMultiSelect() {
    return CHECKBOX_MULTISELECT;
}

export function waiting(show?: boolean) {
    let modal = $('#waiting-dlg');
    if(!modal.length) {
        $('body').append(WAITING_DLG_HTML);
        modal = $('#waiting-dlg');
    }
    modal.toggle(show);
    const time = 1000; // time in ms to fade from 0.1 to 1
    const time2 = 2000; // time in ms to fade from 0.1 to 1
    $('.pos .frame').fadeTo(0, 0.1).fadeTo(time, 1);
    $('#surfer_load').fadeTo(0, 0.1).fadeTo(time2, 1);
}

export interface ParsedError extends Error {
    parsedex: { stack: string; clazz: string };
}

type BoxOptions = {
    toastr?: boolean;
    title?: string;
    alert?: boolean;
    opened?: boolean;
};
export const errutil: {
    parse: (data: string | ServerException, ex?: string | Error) => ParsedError;
    box: (data: string | ServerException, ex?: string | Error, options?: BoxOptions) => void;
    ajaxerr(data: unknown, ex?: string | Error, options?: BoxOptions): boolean;
} = {
    _iestack: function() {
        let stack = '';
        /* eslint-disable */
        if(!arguments.callee || !arguments.callee.caller)
            return stack;
        let currentFunction = arguments.callee.caller;
        /* eslint-enable */
        while(currentFunction) {
            const fn = currentFunction.toString();
            const fname = fn.substring(fn.indexOf('function') + 8, fn.indexOf('')) || 'anonymous';
            stack += fname + '\n';
            currentFunction = currentFunction.caller;
        }
        return stack;
    },
    parse: function(data, ex) {
        let stack = '';
        let lex = new Error();
        if(typeof (ex) == 'string') {
            lex = new Error(ex);
            ex = null;
        }
        if(ex) {
            stack = lex.stack || '';
        } else {
            ex = lex;
        }
        if(stack)
            stack += '\n...\n';
        stack += ex.stack || '';

        //        if(!stack)
        //            stack = this._iestack();

        let message = ex.message || '';
        let clazz = '';
        if(typeof (data) == 'string')
            message = message + (data ? ', ' : '') + data;
        //FE server json error
        else if(data?.result && data.message) {
            //it now comes xml escaped
            message = xmlunescapeLite(data.message);
            if(data.stack) {
                if(stack)
                    stack += '\n...\n';
                stack += xmlunescapeLite(data.stack);
            }
            if(data.clazz)
                clazz = data.clazz;
        }

        if(!clazz)
            clazz = Object.prototype.toString.call(ex).slice(8, -1);
        if(!stack)
            stack = 'Unknown stack';

        ex.message = message;
        ex.parsedex = { stack: stack, clazz: clazz };
        return ex;
    },
    box: function(data, ex, options) {
        if(!options)
            options = {};
        if(!ex?.parsedex || (typeof (ex) == 'string'))
            ex = this.parse(data, ex);
        const parsed = ex.parsedex;

        if(options.toastr) {
            toastr.error(ex.message, options.title || 'ATTENZIONE');
            try {
                console.error(parsed.stack);
            } catch(err) { /**/ }
            return;
        }

        if(options.alert) {
            alert(ex.message);
            try {
                console.error(parsed.stack);
            } catch(err) { /**/ }
            return;
        }

        const modal = $('#errorbox-dlg');
        if(!modal.length) {
            /* eslint-disable max-len */
            $('body').append(
                '<div class="modal fade" id="errorbox-dlg">'
                + '<div class="modal-dialog modal-lg">'
                + '<div class="modal-content">'
                + '    <div class="modal-header">'
                + '        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>'
                + '        <h3 id="errorbox-title" class="modal-title text-danger"></h3>'
                + '    </div>'
                + '    <div class="modal-body">'
                + '        <p style="white-space: pre-wrap;" id="errorbox-message"></p>'
                + '        <p><button type="button" class="btn btn-warning" data-toggle="collapse" data-target="#errorbox-stack-div">Mostra dettagli di errore</button></p>'
                + '        <div id="errorbox-stack-div" class="collapse" style="padding-top: 1em;">'
                + '            <div style="height: 20em; width: 100%; overflow: scroll;"><pre id="errorbox-stack" style="display: inline-block;"></pre></div>'
                + '        </div>'
                + '    </div>'
                + '    <div class="modal-footer">'
                + '        <button type="button" class="btn btn-primary" data-dismiss="modal">Chiudi</button>'
                + '    </div>'
                + '</div>'
                + '</div>'
                + '</div>',
            );
            /* eslint-enable max-len */
        }

        $('#errorbox-title').text(options.title || 'ATTENZIONE');
        $('#errorbox-message').text(ex.message);
        $('#errorbox-stack').text(parsed.stack);
        if(options.opened)
            $('#errorbox-stack-div').addClass('in');
        else
            $('#errorbox-stack-div').removeClass('in');
        $('#errorbox-dlg').modal({ backdrop: 'static', show: true });
    },
    ajaxerr: function(data, err, options) {
        //FE server json error
        if(data.result && (data.result != 'ok')) {
            this.box(data, err, options);
            return true;
        }
        return false;
    },
};

let _waitingRefs = 0;
export function refCountWaiting(_waiting?: boolean) {
    if(_waiting) {
        if(!_waitingRefs) {
            waiting(true);
        }
        _waitingRefs++;
    } else {
        //wait a little, so simultaneous requests don't flicker
        setTimeout(function() {
            _waitingRefs--;
            if(!_waitingRefs) {
                waiting(false);
            }
        }, 50);
    }
}

export function ajaxWaiting(settings: JQuery.AjaxSettings & {
    // blueimp-file-upload/js/jquery.iframe-transport.js workaround
    fileInput?: JQuery<HTMLInputElement>;
    formAcceptCharset?: string;
}): JQuery.AjaxSettings {
    settings.beforeSend = function() {
        refCountWaiting(true);
    };

    function bindStopEvent(event) {
        if(typeof (settings[event]) == 'function') {
            settings[event] = [function() {
                refCountWaiting(false);
            }, settings[event]];
        } else {
            settings[event].unshift(function() {
                refCountWaiting(false);
            });
        }
    }
    bindStopEvent('success');
    bindStopEvent('error');
    return settings;
}

export const crypt = {
    key: null,
    encrypt: function(data, _key) {
        let k = 0;
        const self = this;
        if(!_key)
            _key = self.key;
        function processByte(b) {
            const key = _key.charCodeAt((k++) % _key.length) & 0xff;
            b ^= key;
            return ('0' + b.toString(16)).slice(-2);
        }
        let s = '';
        for(let i = 0; i < data.length; i++) {
            const c = data.charCodeAt(i);
            s += processByte(c & 0xff);
            s += processByte((c >> 8) & 0xff);
        }
        return s;
    },
    encryptObj: function(obj) {
        for(const name in obj) {
            const val = obj[name];
            if(typeof (val) == 'string')
                obj[name] = this.encrypt(val);
        }
        return obj;
    },
};

export function dbs(_service, _options) {
    const service = _service;
    const options = _options || {};
    function calldbs(fn, request, cb) {
        const query = 'service=' + encodeURIComponent(service) + '&fn=' + encodeURIComponent(fn) + '&request=' + encodeURIComponent(JSON.stringify(request));
        let ajaxargs = {
            type: 'POST',
            url: __ROOT__ + 'db.cmd',
            data: query,
            dataType: 'json',
            success: function(data) {
                if(!options.noalert && errutil.ajaxerr(data)) {
                    return;
                }
                cb(data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(!options.noalert)
                    errutil.box(textStatus, errorThrown);
            },
        };
        if(options.waiting)
            ajaxargs = ajaxWaiting(ajaxargs);
        $.ajax(ajaxargs);
    }
    function bind(self, name) {
        self[name] = function(request, cb) {
            calldbs(name + 'Json', request, cb);
        };
    }
    bind(this, 'getMetadata');
    bind(this, 'getData');
    bind(this, 'modifyData');
    bind(this, 'deleteData');

    this.exportData = function(request) {
        const form = $('#export-data-form');
        if(!form.length) {
            $('body').append(
                '<form id="export-data-form" method="get" action="' + __ROOT__ + 'exportdb.cmd" target="_blank">'
                + '<input type="hidden" name="service" id="export-data-form-service"/>'
                + '<input type="hidden" name="request" id="export-data-form-request"/>'
                + '</form>',
            );
        }
        request = $.extend(true, {}, request);
        delete request.table.firstRow;
        delete request.table.maxRows;
        $('#export-data-form-service').val(_service);
        $('#export-data-form-request').val(JSON.stringify(request));
        $('#export-data-form').submit();
    };
}

export const handler2: {
    handle: TypedApiCall;
    dbs: TypedDbsCall;
} = {
    __handle: function(url, params, options, cb) {
        if(typeof (options) == 'function') {
            cb = options;
            options = null;
        }

        if(!options)
            options = {};
        let deferred;
        if(!cb)
            deferred = $.Deferred();

        const response = function(err, data) {
            if(err) {
                if(!options.noalert)
                    errutil.box(null, err);
                if(!options.errors)
                    return undefined;
                if(cb) {
                    return cb(err);
                }
                return deferred.reject(err);
            }
            if(cb)
                return cb(null, data);
            return deferred.resolve(data);
        };

        let ajaxargs = {
            type: 'POST',
            url: __ROOT__ + url,
            data: params,
            dataType: options.dataType || 'json',
            success: function(data) {
                if(data.result && (data.result != 'ok')) {
                    const err = errutil.parse(data);
                    return response(err);
                }
                return response(null, data);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                const err = errutil.parse(textStatus, errorThrown);
                return response(err);
            },
        };
        if(!options.nowait)
            ajaxargs = ajaxWaiting(ajaxargs);
        if(options.formData) {
            ajaxargs.contentType = false;
            ajaxargs.processData = false;
        }
        $.ajax(ajaxargs);
        if(cb)
            return null;
        //deferred to real promise
        //jquery deferred doesn't support finally
        return Promise.resolve()
            .then(() => deferred.promise());
    },
    handle: function(command, query, options, cb) {
        if(typeof (query) == 'function') {
            cb = query;
            query = null;
            options = null;
        }
        if(!query)
            query = '';
        if(!options)
            options = {};
        let params;
        if(query instanceof FormData) {
            params = query;
            options.formData = true;
        } else {
            const files = query._files_;
            delete query._files_;
            if(files) {
                options.formData = true;
                params = new FormData();
                params.append('params', JSON.stringify(query));
                for(const param in files) {
                    let file = files[param];
                    if(!$.isArray(file))
                        file = [file];
                    for(let i = 0; i < file.length; i++) {
                        params.append(param, file[i]);
                    }
                }
            } else {
                params = { params: JSON.stringify(query) };
            }
        }
        return handler2.__handle(command + '.cmd2', params, options, cb);
    },
    dbs: function(service, fn, request, options, cb) {
        const params = {
            service: service,
            fn: fn + 'Json',
            request: JSON.stringify(request),
        };
        return handler2.__handle('db.cmd', params, options, cb);
    },
};

interface centuryType {
    callfn: TypedCenturyCall;
}

type centuryConstructorType = new(_options?: ApiOptions) => centuryType;

export const century = function(this:centuryType, _options?: ApiOptions) {
    const options = _options || {};
    this.callfn = function(command, query, cb) {
        if(typeof (query) == 'function') {
            cb = query;
            query = command;
        } else {
            query.command = command;
        }
        if(cb) {
            return handler2.handle('CenturyProxyHandler', query, options, function(err, data) {
                if(!err)
                    cb(data && data.ret);
            });
        }
        return handler2.handle('CenturyProxyHandler', query, options)
            .then(function(data) {
                return data && data.ret;
            });
    };
} as centuryConstructorType;

export function getRadioState(name, evt) {
    let checked = false;
    if(!$('#' + name).hasClass('no-validate')) {
        const id = evt && $(evt.target).attr('id');
        if(!id || (id == name))
            checked = $('#' + name + '-on').hasClass('active');
        else
            checked = (id == (name + '-on'));
    }
    return checked;
}

export function bindExclusiveControl(bundles, bundle, control) {
    $('#' + control.id).on('blur', function() {
        if($('#' + control.id).is(':disabled'))
            return;
        let j;
        let disableOthers;
        for(j = 0; j < bundle.length; j++) {
            const t = bundle[j];
            if(!t.ignorevalue)
                disableOthers |= !!$('#' + t.id).val();
        }
        for(j = 0; j < bundles.length; j++) {
            const other = bundles[j];
            if(other === bundle)
                continue;
            for(let k = 0; k < other.length; k++) {
                const o = other[k];
                const ctl = $('#' + o.id);
                ctl.prop('disabled', disableOthers);
                if(disableOthers && o.ignorevalue)
                    ctl.val('');
            }
        }
    });
}

crypt.key = 'bindExclusive';
export function bindExclusive(bundles, bundle) {
    for(let i = 0; i < bundle.length; i++) {
        const control = bundle[i];
        if(control.ignorevalue)
            continue;
        bindExclusiveControl(bundles, bundle, control);
    }
}

export function bindExclusives(allbundles) {
    let i; let
        j;
    for(i = 0; i < allbundles.length; i++) {
        const bundles = allbundles[i].bundles;
        for(j = 0; j < bundles.length; j++) {
            const bundle = bundles[j];
            //normalize
            for(let k = 0; k < bundle.length; k++) {
                if(typeof (bundle[k]) == 'string') {
                    bundle[k] = { id: bundle[k], ignorevalue: false };
                }
            }
            bindExclusive(bundles, bundle);
        }
    }
}

export function executeValidationRules(validator, value, element, rules) {
    for(const method in rules) {
        const rule = { method: method, parameters: rules[method] };
        const result = $.validator.methods[method].call(validator, value, element, rule.parameters);
        if(!result) {
            validator.formatAndAdd(element, rule);
            return false;
        }
    }
    return true;
}

let customValudationInitialized = false;
export function prepareCustomValidationMethods() {
    if(customValudationInitialized) {
        return;
    }
    customValudationInitialized = true;
    function checkIVA(value) {
        let pi = value;
        if(!/^[0-9]{1,11}$/.test(pi))
            return false;
        //normalize
        if(pi.length < 11) {
            pi = String('00000000000' + pi).slice(-11);
        }
        let s = 0;
        const zero = '0'.charCodeAt(0);
        for(let i = 0; i <= 9; i += 2)
            s += pi.charCodeAt(i) - zero;
        for(let i = 1; i <= 9; i += 2) {
            let c = 2 * (pi.charCodeAt(i) - zero);
            if(c > 9) c -= 9;
            s += c;
        }
        const check = ((10 - (s % 10)) % 10);
        if(check != (pi.charCodeAt(10) - zero)) {
            try { console.log(String.fromCharCode(check + zero)); } catch(ex) { /**/ }
            return false;
        }
        return true;
    }

    function checkCF(value) {
        const cf = value.toUpperCase();
        let i; let
            s;
        if(cf.length != 16)
            return false;
        const validi = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        for(i = 0; i < 16; i++) {
            if(validi.indexOf(cf.charAt(i)) == -1)
                return false;
        }
        const set1 = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const set2 = 'ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const setpari = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const setdisp = 'BAKPLCQDREVOSFTGUHMINJWZYX';
        s = 0;
        for(i = 1; i <= 13; i += 2)
            s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
        for(i = 0; i <= 14; i += 2)
            s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));

        if(!(s % 26 == cf.charCodeAt(15) - 'A'.charCodeAt(0))) {
            try { console.log(String.fromCharCode('A'.charCodeAt(0) + (s % 26))); } catch(ex) { /**/ }
            return false;
        }
        return true;
    }

    function checkPaese(value, control) {
        control = $(control);
        if(!control.length || control.is(':disabled'))
            return null;
        const paese = _tabledata.getControlValue(control);
        if(!paese || (paese == 'IT'))
            return null;
        //1..28
        return !!(value && (value.length >= 1) && (value.length <= 28));
    }

    function checkIdCodiceType(value, control) {
        //physical person
        //- "PAS" (passport) per l'identificazione basata sul numero del passaporto
        //- "IDC" (identity card) per l'identificazione basta sul numero della carta d'identità
        //- "PNO" (personal number) per l'identificazione basata su un numero personale di registrazione anagrafica (non esistente in Italia)
        //- "TIN" (tax identification number) per l'identificazione basata sul codice fiscale
        //organization
        //- "VAT" (value added tax) per l'identificazione basata sulla partita IVA.
        //  Se si usa "VAT" in combinazione con il codice di paese "EU",
        //  l'identificatore deve essere conforme alla direttiva del Consiglio 2006/112/EC [i.12], art. 215
        //- "NTR" (national trade register) per l'identificazione basata sul numero di registrazione alla Camera di commercio
        control = $(control);
        if(!control.length || control.is(':disabled'))
            return null;
        const type = _tabledata.getControlValue(control);
        if(type == 'VAT')
            return checkIVA(value);
        if(type == 'TIN')
            return checkCF(value);
        return null;
    }

    jQuery.validator.addMethod('IVA', function(value, element, params) {
        if(this.optional(element) || (params === false))
            return true;
        if(params?.paese) {
            const valido = checkPaese(value, params.paese);
            if(valido !== null)
                return valido;
        }
        return checkIVA(value);
    }, 'Partita IVA non valida');

    jQuery.validator.addMethod('CF', function(value, element, params) {
        if(this.optional(element) || (params === false))
            return true;
        if(params?.paese) {
            const valido = checkPaese(value, params.paese);
            if(valido !== null)
                return valido;
        }
        return checkCF(value);
    }, 'Il Codice Fiscale non risulta formalmente valido');

    jQuery.validator.addMethod('IVAorCF', function(value, element, params) {
        if(this.optional(element) || (params === false))
            return true;
        if(params?.paese) {
            const valido = checkPaese(value, params.paese);
            if(valido !== null)
                return valido;
        }
        if(params?.type) {
            const valido = checkIdCodiceType(value, params.type);
            if(valido !== null)
                return valido;
        }
        return checkIVA(value) || checkCF(value);
    }, 'Il Codice Fiscale o Partita IVA non valida');

    jQuery.validator.addMethod('eq', function(value, element, params) {
        if(!params.force && this.optional(element))
            return true;
        let val;
        if(params.fn) {
            val = params.fn.call(this, value, element);
            params.value = val;
        } else {
            val = params.value || params;
        }
        if(val === null)
            return true;
        return (value == val);
    }, function(params, element) {
        const val = (typeof (params) == 'object') ? params.value : params; return $.validator.format("Valore dovrebbe essere '{0}'", val || '[ vuoto ]');
    });

    jQuery.validator.addMethod('upcase', function(value, element, params) {
        if(this.optional(element))
            return true;
        if(params?.numbers)
            return /^[A-Z0-9]+$/.test(value);
        return /^[A-Z]+$/.test(value);
    }, 'Testo dovrebbe essere in maiuscolo');

    jQuery.validator.addMethod('cap', function(value, element, params) {
        return this.optional(element) || /^\d{5}$/.test(value);
    }, 'CAP non valido');

    jQuery.validator.addMethod('datepicker', function(value, element, params) {
        if(this.optional(element))
            return true;
        const elem = $(element);
        let picker;
        if(elem.is('bs-date-picker')) {
            picker = elem;
        } else {
            picker = elem.parent('div.bs-date-picker');
        }
        let time = null;
        if(picker.length) {
            picker = $(element).closest('.bs-date-picker').data('DateTimePicker');
            try {
                time = picker.getDate();
            } catch(ex) { /**/ }
        } else {
            const val = elem.val();
            const result = /^(\d{2})\/(\d{2})\/(\d{4})( (\d{2}):(\d{2}))?$/.exec(val);
            if(result) {
                time = new timeformat(val).toMoment();
            }
        }

        if(params?.before) {
            const before = moment().add(params.before, 'day').startOf('day');
            if(moment(time).isAfter(before))
                return false;
        }
        return !!time;
    }, function(params, element) {
        if(params?.before) {
            const before = moment().add(params.before, 'day').startOf('day');
            return $.validator.format("Deve essere prima del '{0}'", new timeformat(before).toDisplayTime({ needTime: false }));
        }
        return 'Data non valida';
    });

    jQuery.validator.addMethod('weight', function(value, element, params) {
        return this.optional(element) || /^[0-9]{1,4}\.[0-9]{1,2}$/.test(value);
    }, 'Altezza non valida');

    jQuery.validator.addMethod('rate', function(value, element, params) {
        return this.optional(element) || (/^[0-9]{1,3}\.[0-9]{2}$/.test(value) && (Number(value) <= 100.00));
    }, 'Valore non valido');

    jQuery.validator.addMethod('notzero', function(value, element, params) {
        return this.optional(element) || ((!Number.isNaN(Number(value))) && (Number(value) !== 0));
    }, 'Valore non può essere zero');

    jQuery.validator.addMethod('decimal', function(value, element, params) {
        function topattern(field) {
            if(!params?.[field]) {
                return '\\d+';
            }
            let val = params[field];
            if(typeof (val) == 'number')
                val = [val, val];
            else if(val.length == 1)
                val = [val[0], val[0]];
            return '\\d{' + val[0] + ',' + val[1] + '}';
        }

        let restr = '^';
        if(!params?.positive)
            restr += '\\-?';

        restr += topattern('integer');

        if(!params?.fractional)
            restr += '(?:\\.';
        else
            restr += '\\.';
        restr += topattern('fract');
        if(!params?.fractional)
            restr += ')?';
        restr += '$';

        return this.optional(element) || new RegExp(restr).test(value);
    }, 'Inserisci un numero valido');

    jQuery.validator.addMethod('multivalue', function(value, element, params) {
        if(this.optional(element))
            return true;
        let rules = params;
        let separator = ',';
        if(rules.rules) {
            if(rules.separator)
                separator = rules.separator;
            rules = rules.rules;
        }
        const values = value.split(separator);
        for(let i = 0; i < values.length; i++) {
            if(!values[i])
                return false;
            if(!executeValidationRules(this, values[i], element, rules))
                return false;
        }
        return true;
    }, 'Valore non valido');

    jQuery.validator.addMethod('mintable', function(value, element, params) {
        if(typeof (params[1]) == 'function') {
            if(!params[1]())
                return true;
        }
        const table = $('#' + $(element).attr('data-table-ref'));
        const processor = table.data('fe.table-prcessor');
        const size = processor ? processor.count : table.children('tbody').children('tr').length;
        const minsize = params[0];
        return size >= minsize;
    }, 'Inserisci almeno {0} riga');

    jQuery.validator.addMethod('autovalidate', function(value, element) {
        return $(element).is('.data-filled');
    }, 'Valore non valido');

    jQuery.validator.addMethod('attribute', function(value, element) {
        return !$(element).is('[data-validation-invalid]');
    }, function(params, element) {
        const message = $(element).attr('data-validation-invalid');
        if(!message || (message === 'true') || (message === 'false'))
            return 'Valore non valido';
        return 'Valore non valido: ' + message;
    });

    $.validator.addMethod('destinatario', function(value, element, params) {
        if(this.optional(element)) {
            return true;
        }
        let _params = params;
        if(!_params || (_params === true)) {
            _params = {};
        }
        if(!_params.pa && !_params.b2b) {
            _params.pa = true;
            _params.b2b = true;
        }
        if(value.indexOf('@') > 0) {
            if(!_params.b2b)
                return false;
            if((value.length < 7) || (value.length > 256))
                return false;
            return $.validator.methods.email.call(this, value, element, params);
        }
        const valid = /^[A-Za-z0-9]{6,7}$/.test(value);
        if(!valid)
            return false;
        if((value.length == 7) && !_params.b2b)
            return false;
        if((value.length == 6) && !_params.pa)
            return false;
        return true;
    }, function(params, element) {
        let _params = params;
        if(!_params || (_params === true)) {
            _params = {};
        }
        if(!_params.pa && !_params.b2b) {
            _params.pa = true;
            _params.b2b = true;
        }
        if(_params.pa && _params.b2b)
            return 'Il Codice destinatario deve essere un codice di 6,7 caratteri oppure un indirizzo PEC';
        if(_params.pa)
            return 'Il Codice destinatario deve essere un codice di 6 caratteri';
        if(_params.b2b)
            return 'Il Codice destinatario deve essere un codice di 7 caratteri oppure un indirizzo PEC';
        return '';
    });
    $.validator.addMethod('phone', function(value, element, params) {
        if(this.optional(element)) {
            return true;
        }
        return /^\+[0-9]{5,15}$/.test(value);
    }, 'Numero di telefono non valido');
    $.validator.addMethod('phone_or_email', function(value, element, params) {
        if(this.optional(element)) {
            return true;
        }
        if(value.indexOf('@') > 1)
            return $.validator.methods.email.call(this, value, element, params);
        return $.validator.methods.phone.call(this, value, element, params);
    }, 'Valore non valido');
}

export function checkAnyFilledGroup(group) {
    let filled = false;
    for(let i = 0; i < group.length; i++) {
        const ctl = $('#' + group[i]);
        if(!ctl.is(':disabled') && !ctl.is('.no-validate') && ctl.val()) {
            filled = true;
            break;
        }
    }
    return filled;
}

export function setupAutoprettifyControls(parent: JQuery<Node>) {
    function cleanStr(s, multiline) {
        // clean string
        s = s.replace(/[\u00ad\u2012\u2013\u2014\u2015]/g, '-');
        s = s.replace(/[\u2018\u2019\u201b]/g, "'");
        s = s.replace(/[\u00ab\u00bb\u201c\u201d\u201f]/g, '"');
        // control codes
        s = s.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x80-\x9F]/g, '?');
        s = s.replace(/[\t]/g, ' ');
        if(!multiline)
            s = s.replace(/[\r\n]/g, '');
        // all other not from latin set
        s = s.replace(/[^\x00-\xFF]/g, '?');
        return s;
    }

    const input = parent.is('input[type="text"],textarea') ? parent : parent.find('input[type="text"],textarea');
    input.on('blur', function(evt) {
        const el = $(evt.target);
        const val = el.val();
        let trval = $.trim(val);
        trval = cleanStr(trval, $(evt.target).is('textarea'));
        if(val != trval) {
            el.val(trval);
            //revalidate
            if(typeof (el.valid) == 'function')
                el.valid();
        }
    });
}

export function setupAutofillControls(validator: JQueryValidation.Validator) {
    const rules = validator.settings.rules;
    for(const name in rules) {
        const el = $('#' + name);
        if(el.length)
            setupAutofillControl(el, rules[name], validator);
    }
}

export function setupAutofillControl(el: JQuery<Node>, rule: Record<string, unknown>, _validator: JQueryValidation.Validator) {
    let fract = 0;
    if(rule.decimal?.fractional) {
        fract = rule.decimal.fract;
        if(typeof (fract) != 'number')
            fract = fract[0];
    } else if(rule.rate) {
        fract = 2;
    } if(rule.weight) {
        fract = 1;
    }
    if(fract) {
        el.on('blur autoformat', function() {
            const value = el.val();
            if(!value)
                return;
            let nval = value;
            const re = /(\.)(\d*)$/;
            const match = re.exec(nval);
            if(!match?.[1])
                nval += '.';
            let d = fract - ((!match?.[2]) ? 0 : match[2].length);
            while(d > 0) {
                nval += '0';
                d--;
            }
            if(nval != value) {
                el.val(nval);
                _validator.element(el);
            }
        });
    }
    if(rule.cap) {
        el.on('blur autoformat', function() {
            const value = el.val();
            if(!value)
                return;
            let nval = value;
            if(nval.length < 5) {
                nval = String('00000' + nval).slice(-5);
            }
            if(nval != value) {
                el.val(nval);
                _validator.element(el);
            }
        });
    }
    if(rule.upcase || rule.CF) {
        el.on('blur', function() {
            const value = el.val();
            if(!value)
                return;
            const nval = value.toUpperCase();
            if(nval != value) {
                el.val(nval);
                _validator.element(el);
            }
        });
    }
    if(rule.destinatario) {
        el.on('blur', function() {
            const value = el.val();
            if(!value)
                return;
            if(/^[A-Za-z0-9]{6,7}$/.test(value)) {
                const nval = value.toUpperCase();
                if(nval != value) {
                    el.val(nval);
                    _validator.element(el);
                }
            }
        });
    }
    const ivadef = rule.IVA || rule.IVAorCF;
    if(ivadef) {
        const paese = ivadef.paese;
        el.on('blur autoformat', function() {
            const value = el.val();
            if(!value)
                return;
            if(paese) {
                const control = $(paese);
                if(control.length && !control.is(':disabled')) {
                    //don't change/prettify value if paese != IT
                    const paeseval = control.val();
                    if(paeseval && (paeseval != 'IT'))
                        return;
                }
            }
            let nval = value;
            if((nval[0] >= '0') && (nval[0] <= '9') && (nval.length < 11)) {
                nval = String('00000000000' + nval).slice(-11);
            }
            nval = nval.toUpperCase();
            if(nval != value) {
                el.val(nval);
                _validator.element(el);
            }
        });
    }
    if(rule.iban) {
        el.on('blur autoformat', function() {
            const value = el.val();
            if(!value)
                return;
            const nval = value.replace(/\s+/g, '').toUpperCase();
            if(nval != value) {
                el.val(nval);
                _validator.element(el);
            }
        });
    }
    if(rule.phone || rule.phone_or_email) {
        el.on('blur autoformat', function() {
            const value = el.val();
            if(!value || (value.indexOf('@') > 1))
                return;
            let nval = value;
            nval = nval.replace(/\s+/g, '');
            nval = nval.replace(/[.\-()[]_]+/g, '');
            if(nval.charAt(0) != '+') {
                if((nval.substring(0, 2) != '39') || (nval.length <= 10))
                    nval = '39' + nval;
                nval = '+' + nval;
            }
            if(nval != value) {
                el.val(nval);
                _validator.element(el);
            }
        });
    }
}

export function bindCustomSelect(
    el: JQuery<Node>,
    array: string[] | Record<string, string> | Map<string, string>,
    options?: Partial<Select2Options> & { nousertext?: boolean },
) {
    if(!options)
        options = {};
    options.dropdownAutoWidth = true;
    const nousertext = options.nousertext;
    options.query = function(query) {
        const data = [];
        if(query.term && !nousertext)
            data.push({ id: query.term, text: query.term });
        if($.isArray(array)) {
            for(let i = 0; i < array.length; i++) {
                data.push({ id: array[i], text: array[i] });
            }
        } else if(array instanceof Map) {
            for(const [key, value] of array) {
                data.push({ id: key, text: value });
            }
        } else {
            for(const name in array) {
                data.push({ id: name, text: array[name] });
            }
        }
        query.callback({ results: data });
    };
    options.initSelection = function(element, callback) {
        let data;
        if($.isArray(array)) {
            data = { id: element.val(), text: element.val() };
        } else if(array instanceof Map) {
            data = { id: element.val(), text: array.get(element.val()) || element.val() };
        } else {
            data = { id: element.val(), text: array[String(element.val())] || element.val() };
        }
        callback(data);
    };
    el.select2(options);
}


export function makeFullScreenControlHeight(control) {
    //control height = window height - siblings height - parent borders - parent siblings height
    //occupied height = document height - control height
    function resizeToFullScreen(ctl) {
        const space = $(window).height();
        let occupied = $('body').outerHeight(true);
        //if body is 100%
        if(occupied == space) {
            occupied = 0;
            $('body').children().filter(':visible').each(function() {
                occupied += $(this).outerHeight(true);
            });
        }
        occupied -= ctl.outerHeight(true);
        const size = Math.max(space - occupied - 10, 40);
        ctl.height(size);
    }
    $(window).on('resize', function() {
        resizeToFullScreen($(control));
    });
    resizeToFullScreen($(control));
}

export type TimeLike = string | Date | number | moment.Moment | 'now';
type TimeFormatOptions = { needTime?: boolean; zone?: boolean };

declare class timeformatType {
    constructor(time: TimeLike, options?: { forceUtc: boolean });
    toMoment(): moment.Moment;
    toDate(): Date;
    toMillis(): number;
    toXml(options?: TimeFormatOptions): string;
    toDisplayTime(options?: TimeFormatOptions): string;
    toLocalizedTime(options?: TimeFormatOptions): string;

    static fixDateXml(time: TimeLike): string;
    static rawDisplayTimeToXml(time: string): string;
    static rawXmlToDisplayTime(time: string): string;
}

type timeformatConstructorType = new(time: TimeLike, options?: { forceUtc: boolean }) => timeformatType;

//can accept
//- UI datetime in format DD/MM/YYYY HH:mm
//- xml datetime in ISO8601 format
//- JavaScript Date
//- moment
//- any other formats moment constructor accept
//in case of UI and xml datetime automatically determines if time part is set, and can convert to corresponding UI/xml format
//dates are treated very special, they are always in UTC with time set to 00:00:00, Z is never added to the end, so they convert to the same dates always
function timeformat(this:timeformatType, time, options) {
    if(!options)
        options = {};
    if(options.forceUtc === undefined)
        options.forceUtc = false;

    const params = {
        forceUtc: options.forceUtc,
        haveTime: true,
    };

    function parseSpecialFormats(time2) {
        if(!time2 || (typeof (time2) != 'string'))
            return time2;
        let obj = timeformat._splitDisplayTime(time2);
        if(!obj) {
            obj = timeformat._splitXmlTime(time2);
            //will be parsed automatically by moment.js
            if(!obj || (obj.haveTime && !params.forceUtc))
                return time2;
        }
        params.haveTime = obj.haveTime;
        params.forceUtc = params.forceUtc || !obj.haveTime;
        const array = [obj.year, obj.month - 1, obj.day];
        if(obj.haveTime)
            array.push(obj.hour, obj.minute, obj.second, obj.millisecond);
        if(params.forceUtc)
            time2 = moment.utc(array);
        else
            time2 = moment(array);
        return time2;
    }

    time = parseSpecialFormats(time);
    if(time) {
        if(time === 'now')
            time = moment();
        else if(!moment.isMoment(time))
            time = moment(time);
    }

    this.toMoment = function() {
        return time?.clone();
    };
    this.toDate = function() {
        return time?.clone().toDate();
    };
    this.toMillis = function() {
        return time?.toDate().getTime();
    };

    function formatTime(_format, options2) {
        if(!time)
            return time;
        if(!options2)
            options2 = {};
        if(options2.needTime === undefined)
            options2.needTime = params.haveTime;
        if(options2.zone === undefined)
            options2.zone = params.haveTime;

        let format = _format.date;
        if(options2.needTime) {
            format += _format.sep || '';
            format += _format.time;
            format += _format.millis || '';
        }
        if(options2.zone)
            format += _format.Z || '';
        if(params.forceUtc || _format.utc)
            time.utc();
        else
            time.local();
        return time.format(format);
    }
    this.toXml = function(options2) {
        return formatTime({
            utc: true,
            date: 'YYYY-MM-DD',
            sep: '[T]',
            time: 'HH:mm:ss',
            millis: '.SSS',
            Z: '[Z]',
        }, options2);
    };
    this.toDisplayTime = function(options2) {
        return formatTime({
            utc: false,
            date: 'DD/MM/YYYY',
            sep: ' ',
            time: 'HH:mm',
        }, options2);
    };
    this.toLocalizedTime = function(options2) {
        return formatTime({
            utc: false,
            date: 'DD/MM/YYYY',
            sep: ' ',
            time: 'HH:mm:ss',
        }, options2);
    };
}
timeformat._displayTimeRegex = /^(\d{2})\/(\d{2})\/(\d{4})( (\d{2}):(\d{2}))?$/;
timeformat._splitDisplayTime = function(time) {
    const result = timeformat._displayTimeRegex.exec(time);
    if(!result)
        return null;
    const haveTime = result[4];
    const obj = {
        year: result[3], month: result[2], day: result[1], hour: '00', minute: '00', second: '00', millisecond: '000', haveTime: haveTime,
    };
    if(haveTime) {
        obj.hour = result[5];
        obj.minute = result[6];
    }
    return obj;
};
timeformat._xmlTimeRegex = /^(\d{4})-(\d{2})-(\d{2})(T(\d{2}):(\d{2}):(\d{2})(\.\d{3})?)?(Z|[+-]\d{1,2}(:\d{1,2})?)?$/;
timeformat._splitXmlTime = function(time) {
    const result = timeformat._xmlTimeRegex.exec(time);
    if(!result)
        return null;
    const haveTime = result[4];
    const obj = {
        year: result[1], month: result[2], day: result[3], hour: '00', minute: '00', second: '00', millisecond: '000', haveTime: haveTime,
    };
    obj.fullDate = obj.year + '-' + obj.month + '-' + obj.day;
    if(haveTime) {
        obj.hour = result[5];
        obj.minute = result[6];
        obj.second = result[7];
        obj.millisecond = result[8];
    }
    if(result[9])
        obj.zone = result[9];
    return obj;
};
//throws away all crap like 00:00:00+02:00 and returns only date part without zone info
timeformat.fixDateXml = function(value) {
    if(!value)
        return value;
    if(typeof (value) != 'string')
        value = new timeformat(value).toXml({ date: true, Z: false });
    const obj = timeformat._splitXmlTime(value);
    if(!obj)
        return value;
    return obj.fullDate;
};
//converted as is, no zone info stored/converted
timeformat.rawDisplayTimeToXml = function(value) {
    if(!value)
        return value;
    const obj = timeformat._splitDisplayTime(value);
    if(!obj)
        return value;
    return obj.year + '-' + obj.month + '-' + obj.day + (obj.haveTime ? ('T' + obj.hour + ':' + obj.minute + ':' + obj.second) : '');
};
timeformat.rawXmlToDisplayTime = function(value) {
    if(!value)
        return value;
    const obj = timeformat._splitXmlTime(value);
    if(!obj)
        return value;
    return obj.day + '/' + obj.month + '/' + obj.year + (obj.haveTime ? (' ' + obj.hour + ':' + obj.minute) : '');
};

const _timeformat = timeformat as timeformatConstructorType;
export { _timeformat as timeformat };


export const tablerender: {
    renderDate: (data: TimeLike | null | undefined) => string;
    renderCheckbox: (data: string) => string;
    renderRadioButton: (data: string) => string;
    getNameFromAnagrafica: (data: { Denominazione?: string | null; Nome?: string | null; Cognome?: string | null }) => string;
    renderBytes: (data: string | number | null | undefined) => string;
    renderPrettyNum: (data: string | number) => string;
    renderFlag: (data: string | number | null | undefined) => string;
    renderFlagInvert: (data: string | number | null | undefined) => string;
    visualizationSupported: (dataContentType: string | undefined, dataFileName: string | undefined, dataSize: string | number | undefined) => boolean;
} = {
    renderDate: function(data, type, full, meta) {
        return new timeformat(data).toDisplayTime();
    },
    renderCheckbox: function(data, type, full, meta) {
        if(!data)
            return '';
        return '<input type="checkbox" class="table-selector" data-id="' + data + '"></input>'
            + '<div class="company-data__select_help">'
            + '<span class="pc_help">Premi SHIFT/CTRL per attivare la selezione multipla</span>'
            + '<span class="mb_help">Per attivare la selezione multipla premi la casella per tre secondi</span>'
            + '</div>';
    },
    renderRadioButton: function(data, type, full, meta) {
        return '<input type="radio" class="table-selector" data-id="' + data + '" name="table-selector"></input>';
    },
    getNameFromAnagrafica: function(data) {
        if(data.Denominazione)
            return data.Denominazione;
        const n1 = data.Nome;
        const n2 = data.Cognome;
        return (n1 || '') + ((n1 && n2) ? ' ' : '') + (n2 || '');
    },
    renderBytes: function(data, type, full, meta) {
        if(!data)
            return '';
        const bytes = Number(data);
        if(Number.isNaN(bytes))
            return '';
        if(bytes == 0) return '0 Byte';
        const abytes = Math.abs(bytes);
        const decimals = 3;
        const k = 1024;
        const dm = decimals + 1 || 3;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(abytes) / Math.log(k));
        return ((bytes < 0) ? '- ' : '') + (abytes / k ** i).toPrecision(dm) + ' ' + sizes[i];
    },
    renderPrettyNum: function(data) {
        return prettyNums2(data || '', true) || '';
    },
    renderFlag: function(data) {
        return ((data == '1') || (data == 1)) ? 'Sì' : 'No';
    },
    renderFlagInvert: function(data) {
        return ((data == '1') || (data == 1)) ? 'No' : 'Sì';
    },
};

tablerender.visualizationSupported = (function() {
    const SUPPORTED_CONTENT_TYPES = {
        'application/pdf': true,
        'text/xml': true,
        'application/xml': true,
        'application/pkcs7': true,
        'application/msword': true,
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': true,
        'application/vnd.oasis.opendocument.text': true,
        'application/vnd.ms-excel': true,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': true,
        'application/vnd.oasis.opendocument.spreadsheet': true,
        'message/rfc822': true,
        'application/vnd.ms-outlook': true,
        'image/jpeg': true,
        'image/png': true,
        'application/zip': true,
        'application/x-7z-compressed': true,
        'application/x-rar-compressed': true,
    };
    const SUPPORTED_EXTENSIONS = /\.(pdf|xml|p7m|p7k|doc|docx|odt|xls|xlsx|ods|eml|msg|jpg|jpeg|png|zip|7z|rar)$/i;
    const MAX_VIEW_SIZE = 5242880;
    return function visualizationSupported(dataContentType, dataFileName, dataSize) {
        let is_supported = false;
        if(dataContentType && SUPPORTED_CONTENT_TYPES[dataContentType.toLowerCase()])
            is_supported = true;
        else if(dataFileName && SUPPORTED_EXTENSIONS.test(dataFileName))
            is_supported = true;
        if(dataSize && Number(dataSize)) {
            if(Number(dataSize) > MAX_VIEW_SIZE)
                is_supported = false;
        }
        return is_supported;
    };
})();

type OffFunction = () => void;
export const tabledata: {
    getControlValue: (ctl: string | JQuery<Node>) => string;
    setControlValue: (ctl: string | JQuery<Node>, val: string) => JQuery<Node>;
    bindDatatableSearchWithDelay: (table: Node | JQuery<Node>, options?: {
        minlength?: number;
        delay?: number;
    }) => void;
    applyTableFilter: (query: unknown, defs: unknown, filter: unknown, bool?: string, mergeFilter?: unknown, mergeBool?: string) => void;
    applyTableOrder: (query: unknown, data: unknown) => unknown;

    bindCheckboxSelectors: (table: JQuery<Node>, select_all_none?: JQuery<Node>) => OffFunction;
    bindRowSelectors: (table: JQuery<Node>) => OffFunction;
    bindRadioSelectors: (table: JQuery<Node>) => OffFunction;
    fixFilterLike: (val: string) => string;
    debouncedFunction: (mayApply: () => unknown, delay?: number, noReentrant?: boolean) => (applyNow?: boolean) => void;
} = {
    getControlValue: function(ctl) {
        if(typeof (ctl) == 'string')
            ctl = $('#' + ctl);
        if(ctl.is('.yesnocheckbox'))
            ctl = ctl.closest('div[data-toggle]');

        let value = '';
        //country_select is also select2 based
        if(ctl.is('.select2-enabled') || ctl.is('.country_select')) {
            value = ctl.select2('val');
        } else if(ctl.is('[type="checkbox"]')) {
            value = ctl.prop('checked') ? '1' : '0';
        } else if(ctl.is('div[data-toggle]')) {
            value = ctl.find('[name]:checked').val();
        } else if(ctl.is('.bs-date-picker-xml')) {
            value = ctl.val();
            const isTimePicker = ctl.is('.datetime-picker') || ctl.parent().is('.datetime-picker');
            value = new timeformat(value).toXml({ needTime: isTimePicker });
        } else if(ctl.is('[type=file]')) {
            value = ctl.prop('files');
            //convert array like object to array
            if(value)
                value = $.makeArray(value);
        } else {
            value = ctl.val();
        }
        return value;
    },
    setControlValue: function(ctl, val) {
        if(typeof (ctl) == 'string')
            ctl = $('#' + ctl);
        if(ctl.is('.yesnocheckbox'))
            ctl = ctl.closest('div[data-toggle]');

        if(ctl.is('.select2-enabled') || ctl.is('.country_select')) {
            ctl.select2('val', val);
        } else if(ctl.is('[type="checkbox"]')) {
            ctl.prop('checked', val == '1');
        } else if(ctl.is('div[data-toggle]')) {
            $('#' + ctl.attr('id') + ((val == '1') ? '-on' : '-off')).trigger('click');
        } else if(ctl.is('.bs-date-picker-xml')) {
            const isTimePicker = ctl.is('.datetime-picker') || ctl.parent().is('.datetime-picker');
            val = val && new timeformat(val).toDisplayTime({ needTime: isTimePicker });
            ctl.val(val);
        } else if(ctl.is('[type=file]')) {
            //files are not loaded
        } else {
            ctl.val(val);
        }
        return ctl;
    },
    fixFilterLike: function(val) {
        const char = val.substring(0, 1);
        if((char == '=') && (val.length > 1)) {
            val = val.substring(1);
        } else {
            if(char != '%') val = '%' + val;
            if(!val.endsWith('%')) val += '%';
        }
        return val;
    },
    applyTableFilter: function(query, defs, filter, bool, mergeFilter, mergeBool) {
        if(!filter)
            filter = [];
        for(const name in defs) {
            let arrdef = defs[name];
            if(!$.isArray(arrdef))
                arrdef = [arrdef];
            for(let i = 0; i < arrdef.length; i++) {
                let def = arrdef[i];
                if(!def)
                    def = {};
                let val = def.value;
                if((val === undefined) || (val === null))
                    val = tabledata.getControlValue(def.ctl || name);
                val = val?.trim();
                if(!val)
                    continue;
                if(def.nullable) {
                    if(val == '----') {
                        filter.push({ compare: 'is null', filter: [{ column: name }] });
                        continue;
                    } else if(val == '++++') {
                        filter.push({ compare: 'is not null', filter: [{ column: name }] });
                        continue;
                    }
                }
                let op = def.op || '=';
                if(typeof (op) == 'function') {
                    op = op(val);
                }
                if(op == 'like') {
                    val = tabledata.fixFilterLike(val);
                }
                const type = def.type || 'string';
                if((type == 'date') || (type == 'dateTime'))
                    val = new timeformat(val).toXml();
                if(def.filter) {
                    const f = (typeof (def.filter) == 'function') ? def.filter(val, op, type) : def.filter;
                    if(f)
                        filter.push(f);
                    continue;
                }
                filter.push({
                    compare: op,
                    filter: [
                        { column: name },
                        { 'const': val, 'type': type },
                    ],
                });
            }
        }

        if(!filter.length) {
            filter = null;
        } else if(filter.length > 1) {
            filter = [{
                bool: bool || 'and',
                filter: filter,
            }];
        }
        if(mergeFilter) {
            if(filter) {
                filter = [{
                    bool: mergeBool || 'and',
                    filter: [...mergeFilter, ...filter],
                }];
            } else {
                filter = mergeFilter;
            }
        }
        if(filter) {
            query.table.filter = filter;
        }
    },
    applyTableOrder: function(query, data) {
        const order = [];
        for(let i = 0; i < data.order.length; i++) {
            const o = data.order[i];
            let column = data.columns[o.column];
            column = column.data;
            const odef = {};
            odef[column] = o.dir;
            order.push(odef);
        }
        if(!query)
            return order;
        query.table.order = order;
        return undefined;
    },
    bindTableFilterControl: function(table, control) {
        if(control.is('.select2-enabled')) {
            if(control.is('select'))
                control.select2({ dropdownAutoWidth: true });
            control.on('change', function(e) {
                table.DataTable().draw(true);
            });
        } else {
            tabledata.bindCustomSearchWithDelay(control, function(value) {
                table.DataTable().draw(true);
            });
        }
    },
    bindTableFilterControls: function(table) {
        if(typeof (table) == 'string')
            table = $('#' + table);
        table.find('.table-th-filter [name]').each(function() {
            tabledata.bindTableFilterControl(table, $(this));
        });
    },
    bindCheckboxSelectors: function(table, select_all_none) {
        const namespace = '.checkbox.selector';
        let start;
        let end;
        if(select_all_none) {
            select_all_none.on(`click${namespace}`, function() {
                const checked = select_all_none.is(':checked');
                table.find('.table-selector').prop('checked', checked);
                table.trigger('fe.selection-changed');
            });
        }
        table.on(`click${namespace}`, '.table-selector', function(evt) {
            const toggle = !evt.shiftKey;
            const ctlKe = !evt.ctrlKey;
            let checked = true;
            // if (DISPLAY_WIDTHS.user >= DISPLAY_WIDTHS.xl) {
            if(!CHECKBOX_MULTISELECT) {
                table.find('.table-selector').each(function() {
                    const ctl = $(this);

                    let ctlChecked = ctl.is(':checked');
                    if(toggle && ctlKe && (this !== evt.target) && ctlChecked) {
                        ctl.prop('checked', false);
                        ctlChecked = false;
                    }
                    if(!ctlChecked) {
                        checked = false;
                        $(this).parent().parent().removeClass('selected');
                    }
                });
                if(select_all_none)
                    select_all_none.prop('checked', checked);
                table.trigger('fe.selection-changed');
                // }
            } else if(CHECKBOX_MULTISELECT) {
                table.trigger('fe.selection-changed');
            }
        });
        table.on(`touchstart${namespace}`, '.table-selector', function() {
            start = new Date();
        });
        table.on(`touchend${namespace}`, '.table-selector', function() {
            end = new Date();
            const delta = end - start;
            if(DISPLAY_WIDTHS.user < DISPLAY_WIDTHS.xl && delta > LONGPRESS_DURATION) {
                CHECKBOX_MULTISELECT = true;
                $('.multiselect-cancel').fadeIn('fast');
            }
        });
        table.on(`draw.dt${namespace}`, function() {
            if(select_all_none) {
                select_all_none.prop('checked', false);
            }
            table.trigger('fe.selection-changed');
        });
        return function off() {
            if(select_all_none) {
                select_all_none.off(`click${namespace}`);
            }
            table.off(`click${namespace}`);
            table.off(`touchstart${namespace}`);
            table.off(`touchend${namespace}`);
            table.off(`draw.dt${namespace}`);
        };
    },
    bindRowSelectors: function(table) {
        const namespace = '.row.selector';
        if(!(table instanceof jQuery)) {
            table = $('#' + String(table));
        }
        table.on(`click${namespace}`, 'tbody tr', function() {
            const ctl = $(this);
            ctl.parent().find('.selected').not(ctl).removeClass('selected');
            ctl.toggleClass('selected');
            table.trigger('fe.selection-changed');
        });
        table.on(`draw.dt${namespace}`, function() {
            table.trigger('fe.selection-changed');
        });
        return function off() {
            table.off(`click${namespace}`);
            table.off(`draw.dt${namespace}`);
        };
    },
    bindRadioSelectors: function(table) {
        //generalization
        const namespace = '.radio.selector';
        table.on(`click${namespace}`, '.table-selector', function() {
            table.trigger('fe.selection-changed');
        });
        table.on(`draw.dt${namespace}`, function() {
            table.trigger('fe.selection-changed');
        });
        return function off() {
            table.off(`click${namespace}`);
            table.off(`draw.dt${namespace}`);
        };
    },
    DEFAULT_MIN_LENGTH: 0,
    // 30 seconds
    DEFAULT_SEARCH_DELAY: 30000,
    //should be called from initComplete
    bindDatatableSearchWithDelay: function(table, options) {
        table = $(table);
        const dataTable = table.DataTable();
        const settings = dataTable.settings()[0];
        //heavilly inside datatables sources
        let div = $(settings.aanFeatures.f);
        if(!div.length)
            div = table.find('div.dataTables_filter');
        const input = div.find('input[type="search"]');
        input.off('keyup.DT search.DT input.DT paste.DT cut.DT keypress.DT');
        let noReentrant = false;
        tabledata.bindCustomSearchWithDelay(input, function(value) {
            if(noReentrant)
                return;
            noReentrant = true;
            try {
                dataTable.search(value).draw();
            } finally {
                noReentrant = false;
            }
        }, options);
        table.on('search.dt', function() {
            if(noReentrant)
                return;
            noReentrant = true;
            try {
                input.triggerHandler('blur.SRCH');
            } finally {
                noReentrant = false;
            }
        });
    },
    bindCustomSearchWithDelay: function(input, applyFilter, options) {
        if(!options)
            options = {};
        let minlength = options.minlength;
        const delay = options.delay;

        if((minlength === null) || (minlength === undefined))
            minlength = tabledata.DEFAULT_MIN_LENGTH;

        const doneTypingInterval = delay || tabledata.DEFAULT_SEARCH_DELAY;
        let prevValue = input.val();
        let specialCnt = 0;
        let mayApply = function() {
            const value = $(this).val();
            //is it actual change?
            if(prevValue == value)
                return;
            const length = (value?.length) || 0;
            //if value too short - don't apply filter. unless we entered super secret shortcut - double ctrl+alt+shift+Enter for debuggers :)
            if((length < minlength) && (specialCnt < 2))
                return;
            prevValue = value;
            applyFilter(value);
        };
        mayApply = mayApply.bind(input[0]);
        const mayApplyDebounced = tabledata.debouncedFunction(mayApply, doneTypingInterval);
        input.on('keypress.SRCH input.SRCH change.SRCH search.SRCH paste.SRCH cut.SRCH blur.SRCH', function(evt) {
            let applyNow = false;
            if(evt.which == 13) {
                evt.preventDefault();
                evt.stopPropagation();
                applyNow = true;
            }
            if(evt.type == 'blur') {
                applyNow = true;
            }
            if((evt.which == 13) && evt.ctrlKey && evt.shiftKey && evt.altKey) {
                specialCnt++;
            } else {
                specialCnt = 0;
            }

            mayApplyDebounced(applyNow);
        });
    },
    debouncedFunction: function(mayApply, delay, noReentrant) {
        let typingTimer = null;
        let processing = false;
        const doneTypingInterval = delay || tabledata.DEFAULT_SEARCH_DELAY;
        return function(applyNow) {
            if(noReentrant && processing) return;
            clearTimeout(typingTimer);
            typingTimer = null;
            if(applyNow) {
                processing = true;
                try {
                    mayApply();
                } finally {
                    processing = false;
                }
            } else {
                typingTimer = setTimeout(function() {
                    typingTimer = null;
                    if(noReentrant && processing) return;
                    processing = true;
                    try {
                        mayApply();
                    } finally {
                        processing = false;
                    }
                }, doneTypingInterval);
            }
        };
    },
};
_tabledata = tabledata;


let InitDataTablesCustomFeaturesCalled = false;
export function InitDataTablesCustomFeatures() {
    if(InitDataTablesCustomFeaturesCalled)
        return;
    InitDataTablesCustomFeaturesCalled = true;
    function Export(settings) {
        const self = this;
        settings.SetLastQuery = function(service, query, options) {
            if(!options)
                options = {};
            self.service = service;
            self.lastQuery = $.extend({}, query);
            if(options.export_mode)
                self.lastQuery.export_mode = options.export_mode;
        };
        settings.GetLastQuery = function() {
            return self.lastQuery;
        };
        settings.SetLastResult = function(table) {
            self.rowCount = Number(table.rowCount);
        };
    }

    Export.prototype = {
        elem: null,
        service: null,
        lastQuery: null,
        rowCount: null,
        node: function() {
            if(this.elem)
                return this.elem;
            // eslint-disable-next-line max-len
            const elem = $('<div class="pull-right datatables-bottom-toolbar"><button type="button" class="btn btn-default btn-sm glyphicon glyphicon-floppy-disk" title="Esporta"></button></div>')[0];
            this.elem = elem;
            this.init();
            return elem;
        },
        init: function() {
            const self = this;
            const button = $(this.elem).find('button');
            button.on('click', function() {
                if(!self.service || !self.lastQuery)
                    return;
                const rows = self.rowCount;
                const max = __G_OPTIONS__.exportcsv_max;
                if(rows && !isNaN(rows) && (rows > max)) {
                    if(!confirm('La selezione contiene ' + rows + ' record, saranno exportate solo primi ' + max + ' record.')) {
                        return;
                    }
                }
                new dbs(self.service).exportData(self.lastQuery);
            });
        },
    };

    $.fn.dataTable.ext.feature.push({
        fnInit: function(settings) {
            const filter = new Export(settings);
            return filter.node(); // input element
        },
        cFeature: 'X',
    });

    $.fn.dataTable.ext.pager.simple_numbers_without_ellipses = function(page, pages) {
        let numbers = [];
        const buttons = $.fn.DataTable.ext.pager.numbers_length;
        const half = Math.floor(buttons / 2);

        const _range = function(len, start) {
            let end;
            if(typeof start === 'undefined') {
                start = 0;
                end = len;
            } else {
                end = start;
                start = len;
            }
            const out = [];
            for(let i = start; i < end; i++) { out.push(i); }
            return out;
        };

        if(pages <= buttons) {
            numbers = _range(0, pages);
        } else if(page <= half) {
            numbers = _range(0, buttons);
            numbers.push('ellipsis');
            numbers.push(pages - 1);
        } else if(page >= pages - 1 - half) {
            numbers = _range(pages - buttons, pages);
            numbers.push('ellipsis');
            numbers.push(pages - 1);
        } else {
            numbers = _range(page - half, page + 1);
            numbers.push('ellipsis');
            numbers.push(pages - 1);
        }

        numbers.DT_el = 'span';
        return ['previous', numbers, 'next'];
    };
}

export function FileImporterCommon() { }
FileImporterCommon.inherit = function(obj, prefix) {
    for(const name in FileImporterCommon.prototype)
        obj[name] = FileImporterCommon.prototype[name];
    obj.prefix = prefix || '#';
};
FileImporterCommon.prototype = {
    files: 0,
    prefix: null,
    alwaysReset: false,
    lastStats: null,
    showLog: function(log, stats) {
        const prefix = this.prefix;
        if(!this.alwaysReset) {
            $(prefix + 'fileupload').hide();
            $(prefix + 'import_log_div').show();
            $('.cloud_container').removeClass('active');
            $('.mob_hide').removeClass('active');
        }
        let result = 'text-success';
        if(stats.feerrors || stats.fedenied || ((stats.feimporting !== undefined) && (stats.feimporting != stats.feimported)))
            result = 'text-danger';
        else if(stats.feduplicates)
            result = 'text-warning';

        /* eslint-disable max-len */
        const htmlstats = $(prefix + 'import_stats');
        htmlstats.empty();
        let html = '<p class="log-line ' + result + '">elaborati ' + stats.processed + '/' + stats.files + ' file</p>';
        html += '<p class="log-line ' + result + '">risultati:</p>';
        if(stats.feerrors !== undefined)
            html += '<p class="log-line ' + (stats.feerrors ? 'text-danger' : '') + '">errori: ' + stats.feerrors + '</p>';
        if(stats.fedenied !== undefined)
            html += '<p class="log-line ' + (stats.fedenied ? 'text-danger' : '') + '">accesso negato: ' + stats.fedenied + '</p>';
        if(stats.feduplicates !== undefined)
            html += '<p class="log-line ' + (stats.feduplicates ? 'text-warning' : '') + '">duplicati: ' + stats.feduplicates + '</p>';
        if(stats.fewarnings !== undefined)
            html += '<p class="log-line ' + (stats.fewarnings ? 'text-warning' : '') + '">allarmi: ' + stats.fewarnings + '</p>';
        if(stats.feimporting !== undefined)
            html += '<p class="log-line ' + ((stats.feimporting == stats.feimported) ? 'text-success' : 'text-danger') + '">da importare: ' + stats.feimporting + '</p>';
        if(stats.feimported !== undefined)
            html += '<p class="log-line ' + (((stats.feimporting === undefined) || (stats.feimporting == stats.feimported)) ? 'text-success' : 'text-danger') + '">importati: ' + stats.feimported + '</p>';
        if(stats.fetotal !== undefined)
            html += '<p class="log-line">totale: ' + stats.fetotal + '</p>';
        htmlstats.html(html);
        $(prefix + 'import_log').text(log);
        /* eslint-enable max-len */
    },
    reset: function(now) {
        const prefix = this.prefix;
        this.toggleUploadButtons(true, now);
        $(prefix + 'fileupload-reset').trigger('click');
    },
    buttonsVisible: true,
    /**
    * @type Function
    */
    toggleUploadButtons: function(show, cb) {
        const prefix = this.prefix;
        if(show == this.buttonsVisible)
            return;
        this.buttonsVisible = show;
        // eslint-disable-next-line no-nested-ternary
        const ctl1 = show ? (this.alwaysReset ? $() : $(prefix + 'fileupload-reset')) : $(prefix + 'upload-before-controls');
        // eslint-disable-next-line no-nested-ternary
        const ctl2 = show ? $(prefix + 'upload-before-controls') : (this.alwaysReset ? $() : $(prefix + 'fileupload-reset'));
        if((cb === true) || this.alwaysReset) {
            ctl1.toggle();
            ctl2.toggle();
            if((cb !== true) && cb)
                cb();
            return;
        }
        ctl1.fadeToggle('fast', 'swing', function() {
            ctl2.fadeToggle('fast', 'swing', function() {
                if(cb) cb();
            });
        });
    },
    bindUploadEvents: function() {
        const prefix = this.prefix;
        $(prefix + 'fileupload-reset').on('click', function() {
            const form = $(prefix + 'fileupload');
            form.trigger('fileuploadreset');
            const files = form.find('.files');
            files.find('.cancel').click();
            files.empty();
        });

        const form = $(prefix + 'fileupload');

        form.on('click', '.removeBtn', function() {
            $(this).closest('tr').remove();
        });

        const self = this;
        let log = '';
        let stats = null;
        let done = false;
        let pfileuploaddone = false;
        let pfileuploadfail = false;
        form.bind('fileuploaddone', function(e, data) {
            //avoid reentrance
            if(pfileuploaddone)
                return;
            pfileuploaddone = true;
            if(errutil.ajaxerr(data.result)) {
                //something serious on server side
                self.reset();
                pfileuploaddone = false;
                return;
            }
            log += data.result.log;
            const s = data.result.stats;
            if(!stats) {
                stats = s;
            } else {
                for(const name in stats) {
                    stats[name] += s[name];
                }
            }
            self.files = 0;
            done = true;
            pfileuploaddone = false;
        });
        form.bind('fileuploadfail', function(e, data) {
            //avoid reentrance
            if(pfileuploadfail)
                return;
            pfileuploadfail = true;
            self.reset();
            pfileuploadfail = false;
            if(data.errorThrown == 'abort')
                return;
            errutil.box(data.textStatus, data.errorThrown);
        });
        form.bind('fileuploadchange fileuploadreset', function(e, data) {
            if(e.type == 'fileuploadchange') {
                self.files += data.files.length;
            } else {
                self.files = 0;
            }
            $(prefix + 'files').val(self.files);
            log = '';
            stats = null;
            done = false;
        });
        form.bind('fileuploadstop', function(e, data) {
            if(!done)
                return;
            self.lastStats = stats;
            self.showLog(log, stats);
        });
    },
};

export type FilterManagerDef<D, T> = {
    createControl?: (th: JQuery<Node>, data: D, def: FilterManagerDef<D>, self: FilterManager<D>) => void;
    textbox?: boolean;
    select_js?: boolean;
    init?: { id: string; text: string }[] | Record<string, string> | ((ctl: JQuery<Node>) => void);
    op?: BinaryOperationType | ((value: string, def: FilterManagerDef<D>, ctl: JQuery<Node>) => BinaryOperationType);
    type?: ValueTypeDef;
    nullable?: boolean;
    fn?: (filter: ComplexFilter<T>, value: string, def: FilterManagerDef<D>, single_column: string, op: BinaryOperationType, type: ValueTypeDef) => void;
};
export type FilterManagerOptions<D = unknown, T extends string = D extends object ? keyof D : string> = {
    TABLE_FILTER_INITIALIZED?: boolean;
    defs: Partial<Record<T, FilterManagerDef<D, T>>>;
    handleFilter?: (
        def: FilterManagerDef<D>,
        single_column: string,
        ctl: JQuery<Node>,
        op: BinaryOperationType,
        value: string,
        type: ValueTypeDef,
        single_filter: ComplexObject<T>,
        filter: ComplexFilter<T>,
    ) => void;
    buildFilterCustom?: (table: JQuery<Node>, filter: ComplexFilter<T>) => void;
};
type FilterManagerProtoType<D = unknown, T extends string = D extends object ? keyof D : string> = {
    initFilterControls: (table: JQuery<Node>, columns: unknown) => void;
    updateFilterColumns: () => void;
    uninitFilterControls: () => void;
    applyFilter: () => void;
    buildFilter: () => ComplexFilter<T> | null;
};
export type FilterManager<D = unknown, T extends string = D extends object ? keyof D : string> = FilterManagerOptions<D, T> & FilterManagerProtoType<D, T>;

export function FilterManagerCommon() { }
FilterManagerCommon.inherit = function<D = unknown, T extends string = D extends object ? keyof D : string>(
    obj: FilterManagerOptions<D, T>,
): FilterManager<D, T> {
    for(const name in FilterManagerCommon.prototype)
        obj[name] = FilterManagerCommon.prototype[name];
    return obj;
};
FilterManagerCommon.prototype = {
    table: null,
    __columns: null,
    /**
    * @type Function
    */
    initFilterControls: function(table, columns) {
        this.table = table;
        this.__columns = columns;
        this.updateFilterColumns();
    },
    updateFilterColumns: function() {
        const self = this;
        const table = self.table;
        const columns = self.__columns;
        const defs = self.defs;

        table.find('thead th').each(function(index) {
            const th = $(this);
            if($.fn.DataTable?.isDataTable(table)) {
                const dataTable = table.DataTable();
                index = dataTable.column.index('fromVisible', index);
                try {
                    const colReorder = dataTable.colReorder;
                    if(colReorder) {
                        index = colReorder.order()[index];
                    }
                } catch(err) { /**/ }
            }
            let data = columns[index].data || columns[index].name;
            if(typeof (data) == 'function')
                data = data();
            const def = defs[data];
            if(def && !th.find('.table-th-filter').length) {
                if(def.createControl)
                    def.createControl(th, data, def, self);
                else if(def.textbox)
                    self.initTextbox(th, data, def);
                else if(def.select_js)
                    self.initSelect(th, data, def);
            }
        });

        const th = table.find('.table-th-filter').filter(':not(.table-th-filter-initialized)');
        const select = th.find('.select2-enabled');
        select.on('change', function(e) {
            self.applyFilter();
        });
        select.each(function() {
            const ctl = $(this);
            const def = self.defs[ctl.attr('data-id')];
            if(def.init) {
                if(def.select_js && $.isArray(def.init)) {
                    ctl.select2({ data: def.init, dropdownAutoWidth: true, width: '100' });
                } else if(def.select_js && (typeof (def.init) == 'object')) {
                    bindCustomSelect(ctl, def.init, { dropdownAutoWidth: true, width: '100' });
                } else {
                    def.init(ctl);
                }
            } else {
                ctl.select2({ dropdownAutoWidth: true, width: '100' });
            }
        });

        th.on('click keyup keypress selectstart mousedown mousemove mouseup', function(evt) {
            //prevent th from receiving these events, because otherwise dataTables will grab them
            //click keyup keypress selectstart for dataTables
            //mousedown mousemove mouseup for colReorder
            evt.stopPropagation();
        });
        th.addClass('table-th-filter-initialized');
    },
    uninitFilterControls: function() {
        this.table.find('.table-th-filter').off();
        this.table.find('[data-id]').off();
    },
    initTextbox: function(th, data, def) {
        const self = this;
        const title = th.text();
        // eslint-disable-next-line max-len
        const span = $('<span class="table-th-filter"><input class="form-control input-sm" type="text" placeholder="[' + title + ']" data-id="' + data + '"/></span>').appendTo(th);

        const input = span.find('input');
        if(def.init) {
            input.val(def.init);
        }
        tabledata.bindCustomSearchWithDelay(input, function() {
            self.applyFilter();
        });
    },
    initSelect: function(th, data, def) {
        $('<span class="table-th-filter"><input type="hidden" data-id="' + data + '" class="form-control input-sm select2-enabled"/></span>').appendTo(th);
    },
    applyFilter: function() {
        this.table.DataTable().draw(true);
    },
    buildFilterFromData: function(def, single_column, op, value, type) {
        function buildDateFilter(column) {
            const parts = value.split(/\s*\/\s*/);
            const partsOrder = ['year', 'month', 'day'];
            if(!parts.length || (parts.length > partsOrder.length))
                return null;

            const dateParts = {};
            let idx = 0;
            for(let i = parts.length - 1; i >= 0; i--) {
                const part = Number(parts[i]);
                if(isNaN(part))
                    return null;
                dateParts[partsOrder[idx++]] = parts[i];
            }

            //month is zero based
            if(dateParts.month !== undefined)
                dateParts.month--;

            let dateStart;
            let dateFinish;
            if(dateParts.month === undefined) {
                dateStart = moment.utc([dateParts.year]);
                dateFinish = dateStart.clone().endOf('year');
            } else if(dateParts.day === undefined) {
                dateStart = moment.utc([dateParts.year, dateParts.month]);
                dateFinish = dateStart.clone().endOf('month');
            } else {
                dateStart = moment.utc([dateParts.year, dateParts.month, dateParts.day]);
                dateFinish = dateStart.clone().endOf('day');
            }
            if(!dateStart.isValid() || !dateFinish.isValid())
                return null;

            const needTime = (type == 'dateTime');
            if(needTime) {
                dateStart = moment(dateStart.utc().toArray());
                dateFinish = moment(dateFinish.utc().toArray());
            }
            let filter2 = [{
                compare: '>=',
                filter: [
                    { column: column },
                    { 'const': new timeformat(dateStart).toXml({ needTime: needTime, zone: needTime }), 'type': type },
                ],
            }, {
                compare: '<=',
                filter: [
                    { column: column },
                    { 'const': new timeformat(dateFinish).toXml({ needTime: needTime, zone: needTime }), 'type': type },
                ],
            }];
            filter2 = {
                bool: 'and',
                filter: filter2,
            };
            return filter2;
        }
        let single_filter = null;
        if(def.textbox && ((type == 'date') || (type == 'dateTime'))) {
            single_filter = buildDateFilter(single_column);
        } else {
            if(def.nullable) {
                if(value == '----') {
                    single_filter = { compare: 'is null', filter: [{ column: single_column }] };
                } else if(value == '++++') {
                    single_filter = { compare: 'is not null', filter: [{ column: single_column }] };
                }
            }
            if(!single_filter) {
                single_filter = {
                    compare: op,
                    filter: [
                        { column: single_column },
                        { 'const': value, 'type': type },
                    ],
                };
            }
        }
        return single_filter;
    },
    buildFilter: function() {
        const self = this;
        const table = self.table;
        let filter = [];

        if(self.buildFilterCustom) {
            self.buildFilterCustom(table, filter);
        }

        table.find('.table-th-filter').each(function() {
            const th = $(this);
            if(!th.is(':visible'))
                return;
            const ctl = th.find('[data-id]');
            let value;
            if(ctl.is('.select2-enabled')) {
                value = ctl.select2('val');
            } else {
                value = ctl.val();
            }
            if(value && (typeof (value) == 'string'))
                value = value.trim();
            if(!value)
                return;
            const data = ctl.attr('data-id');
            const def = self.defs[data];
            let op = def.op || '=';
            if(typeof (op) == 'function') {
                op = op(value, def, ctl);
            }
            const type = def.type || 'string';
            if(op == 'like') {
                if(def.nullable && ((value == '----') || (value == '++++'))) {
                    //specials
                } else {
                    value = tabledata.fixFilterLike(value);
                }
            }
            const single_column = data;
            if(def.fn) {
                def.fn(filter, value, def, single_column, op, type);
            } else {
                const single_filter = self.buildFilterFromData(def, single_column, op, value, type);
                if(!single_filter)
                    return;
                if(self.handleFilter)
                    self.handleFilter(def, single_column, ctl, op, value, type, single_filter, filter);
                else
                    filter.push(single_filter);
            }
        });
        if(!filter.length)
            return null;
        if(filter.length > 1) {
            filter = [{
                bool: 'and',
                filter: filter,
            }];
        }
        return filter;
    },
};


export function hexToBase64(str: string) {
    return btoa(String.fromCharCode.apply(
        null,
        str.replace(/\r|\n/g, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' '),
    ));
}

export function base64ToHex(str: string) {
    const hex = [];
    for(let i = 0, bin = atob(str.replace(/[ \r\n]+$/, '')); i < bin.length; ++i) {
        let tmp = bin.charCodeAt(i).toString(16);
        if(tmp.length === 1) tmp = '0' + tmp;
        hex[hex.length] = tmp;
    }
    return hex.join(' ');
}

const XML_CHARACTER_MAP = {
    '&': '&amp;',
    '"': '&quot;',
    "'": '&apos;',
    '<': '&lt;',
    '>': '&gt;',
};
export function xmlescape(string: string) {
    return string?.replace
        ? string.replace(/([&"<>'])/g, function(str, item) {
            return XML_CHARACTER_MAP[item];
        }) : string;
}
const R_XML_CHARACTER_MAP_LITE = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
};
export function xmlunescapeLite(string: string) {
    return string?.replace
        ? string.replace(/(&lt;|&gt;|&amp;)/g, function(str, item) {
            return R_XML_CHARACTER_MAP_LITE[item];
        }) : string;
}

export function unknownPaginator(obj) {
    obj.pagingType = 'full';
    obj.formatNumber = function(iIn) {
        if(iIn == unknownPaginator.MAX_NUMBER)
            return 'unknown';
        return String(iIn);
    };
    obj.drawCallback = function(settings) {
        $(this).parent().find('.paginate_button.last').hide();
    };
    return obj;
}
unknownPaginator.MAX_NUMBER = 1000000;
unknownPaginator.maxNumber = function(data, result) {
    if(!data.start && (result.length < data.length))
        return result.length;
    return unknownPaginator.MAX_NUMBER;
};

export function AdvancedPeriodManager(self, scope) {
    if(!self)
        self = this;
    if(!scope)
        scope = {};
    scope.currentFilter = null;
    self.allowTutti = false;
    /**
    * @type Function
    */
    self.init = function() {
        setupPeriodFilter();
    };
    self.getCurrentFilter = function() {
        if(!scope.currentFilter)
            scope.currentFilter = scope.queryCurrentFilter();
        return scope.currentFilter;
    };
    self.applyFilter = function() {
    };
    scope.applyFilter = function() {
        const currentFilter = scope.queryCurrentFilter();
        if(scope.currentFilter) {
            let changed = false;
            for(const name in currentFilter) {
                if(currentFilter[name] !== scope.currentFilter[name]) {
                    changed = true;
                    break;
                }
            }
            if(!changed)
                return null;
        }
        scope.currentFilter = currentFilter;
        return currentFilter;
    };
    scope.queryCurrentFilter = function() {
        let periodFrom = $('#period-from').data('DateTimePicker').getDate();
        let periodTo = $('#period-to').data('DateTimePicker').getDate();
        if(self.allowTutti && !periodFrom && !periodTo) {
            return {
                from: null,
                to: null,
            };
        }
        if(!periodTo?.isValid())
            periodTo = moment();
        if(!periodFrom?.isValid())
            periodFrom = periodTo.clone().add(-7, 'day');
        periodFrom.hour(0).minute(0).second(0).millisecond(0);
        periodTo.hour(23).minute(59).second(59).millisecond(999);

        return {
            from: new timeformat(periodFrom).toXml(),
            to: new timeformat(periodTo).toXml(),
        };
    };
    function setupPeriodFilter() {
        let processingPickers = false;
        function syncPickers(master, slave, direction, time) {
            if(processingPickers)
                return;
            const interval = $('#period-interval').select2('val');
            if(interval == '--')
                return;
            if(!time)
                time = master.data('DateTimePicker').getDate();
            if(!time?.isValid())
                return;
            const time2 = time.add(Number(interval) * direction, 'day');
            processingPickers = true;
            slave.data('DateTimePicker').setDate(time2);
            processingPickers = false;
        }
        function movePickers(master, slave) {
            if(processingPickers)
                return;
            const time1 = master.data('DateTimePicker').getDate();
            const time2 = slave.data('DateTimePicker').getDate();
            const diff = time1.diff(time2);
            processingPickers = true;
            slave.data('DateTimePicker').setDate(time1);
            master.data('DateTimePicker').setDate(time1.add(Number(diff)));
            processingPickers = false;
        }
        function fixedPeriod(period) {
            $('#period-to').data('DateTimePicker').setDate(moment());
            $('#period-interval').select2('val', period);
            syncPickers($('#period-to'), $('#period-from'), -1);
            //give user some attention if period is short default (7 days)
            $('#fltDate-icon,#fltDate-icon2').toggleClass('text-danger', (period == '7'));
        }
        function hideDropdownMenu() {
            if($('#period-dropdown').is('.open'))
                $('#fltDate').trigger('click');
        }
        $('#period-interval').select2({ dropdownAutoWidth: true });
        $('#period-from,#period-to').datetimepicker({ pickTime: false, language: 'it' });
        $('#period-from').on('dp.change dp.error', function(evt) {
            syncPickers($('#period-from'), $('#period-to'), 1, evt.date);
        });
        $('#period-to').on('dp.change dp.error', function(evt) {
            syncPickers($('#period-to'), $('#period-from'), -1, evt.date);
        });
        $('#period-interval').on('change', function() {
            syncPickers($('#period-to'), $('#period-from'), -1);
        });
        $('#period-move-back').on('click', function(evt) {
            movePickers($('#period-from'), $('#period-to'));
        });
        $('#period-move-forward').on('click', function(evt) {
            movePickers($('#period-to'), $('#period-from'));
        });

        $('#period-apply').on('click', function() {
            hideDropdownMenu();
        });
        $('#period-custom').on('click', function(evt) {
            evt.stopPropagation();
        });
        $('#period-dropdown').on('hidden.bs.dropdown', function() {
            if(scope.applyFilter())
                self.applyFilter();
        });
        $('#period-dropdown').find('.period-fixed').on('click', function(evt) {
            evt.stopPropagation();
            const period = $(this).attr('data-period');
            if(self.allowTutti && (period == 'tutti')) {
                $('#period-interval').select2('val', '--');
                $('#period-from').data('DateTimePicker').setDate(null);
                $('#period-to').data('DateTimePicker').setDate(null);
                $('#fltDate-icon,#fltDate-icon2').toggleClass('text-danger', false);
            } else {
                fixedPeriod(period);
            }
            hideDropdownMenu();
        });
        fixedPeriod('7');
    }

    return self;
}

export function ColVisCustomInit() {
    let ColVis = $.fn.dataTable.ColVis;
    ColVis = ColVis.prototype;
    if(ColVis.ColVisCustomInit) return;
    let globalDialog = null;
    ColVis._fnDomCollection = function() {
        if(!globalDialog) {
            const dialog = '<div id="ColVisSelectorModal" class="modal fade">'
                + '    <div class="modal-dialog">'
                + '        <div class="modal-content">'
                + '            <div class="modal-header">'
                + '                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>'
                + '                <h4 class="modal-title">colonne +/-</h4>'
                + '            </div>'
                + '            <div class="font_wrap">'
                + '            <p class="title">Font size</p>'
                + '           <select class="font_change">'
                + '                <option value="very_small_font">very small</option>'
                + '                <option value="small_font">small</option>'
                + '                <option value="normal_font" selected="true">normal</option>'
                + '                <option value="big_font">big</option>'
                + '                <option value="very_big">very big</option>'
                + '            </select>'
                + '            </div>'
                + '            <div class="modal-body">'
                + '                <form class="form-horizontal">'
                + '                    <ul class="ColVis_collection"/>'
                + '                </form>'
                + '            </div>'
                + '            <div class="modal-footer">'
                + '                <button type="button" class="btn btn-default" data-dismiss="modal">Chiudi</button>'
                + '            </div>'
                + '        </div>'
                + '    </div>'
                + '</div>';
            globalDialog = $(dialog).appendTo($('#content'));
        }
        return globalDialog.find('ul.ColVis_collection')[0];
    };

    ColVis._fnDomBackground = function() {
        return $('<div></div>');
    };
    ColVis._fnCollectionShow = function() {
        globalDialog.modal('show');
    };
    ColVis._fnCollectionHide = function() {
        globalDialog.modal('hide');
    };
    ColVis.ColVisCustomInit = true;
}

// inputmask plugin init
//prettyNums returns number, prettyNums2 - string
export function prettyNums2(num, pretty) {
    if(pretty == undefined) return num;
    if(pretty === true) {
        num = num.toString().split('.');
        num[0] = num[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return num.join(',');
    }
    if(pretty === false) {
        if(typeof num !== 'string') return num;
        num = num.replace(/\./g, '').replace(/,/g, '.');
        return num;
    }
    return undefined;
}

export function isInternalDocumentType(TipoDocumento) {
    return /FA[0-9]{2}/.test(TipoDocumento);
}



export function TagProcessorCommon() { }
TagProcessorCommon.inherit = function(obj) {
    for(const name in TagProcessorCommon.prototype)
        obj[name] = TagProcessorCommon.prototype[name];
};
TagProcessorCommon.SEPARATOR = ';';
TagProcessorCommon.prototype = {
    SEPARATOR: TagProcessorCommon.SEPARATOR,
    TAGS: {},
    RTAGS: {},
    /**
    * @type Function
    */
    init: function(TAGS) {
        this.TAGS = TAGS;
        this.RTAGS = {};
        for(const name in this.TAGS) {
            this.RTAGS[this.TAGS[name]] = name;
        }
    },
    tagsToArray: function(tags) {
        return this.nornalizeTags((tags || '').split(this.SEPARATOR));
    },
    tagsToSelect2: function() {
        const tags = [];
        for(const name in this.TAGS) {
            tags.push({ id: name, text: this.TAGS[name] });
        }
        return tags;
    },
    arrayToTags: function(tags) {
        return this.nornalizeTags(tags).join(this.SEPARATOR);
    },
    nornalizeTags: function(tags) {
        if(!tags)
            return [];
        //remove empty strings
        tags = $.grep(tags, function(tag) { return !!tag; });
        for(let i = 0; i < tags.length; i++) {
            const name = this.RTAGS[tags[i]];
            if(name)
                tags[i] = name;
        }
        return tags;
    },
    formatTags: function(tags, separator, escapeHtml) {
        let message = '';
        for(let i = 0; i < tags.length; i++) {
            let tag = tags[i];
            if(typeof (tag) == 'object')
                tag = tag.name;
            if(tag in this.TAGS)
                tag = this.TAGS[tag];
            if(message)
                message += separator;
            message += escapeHtml ? xmlescape(tag) : tag;
        }
        return message;
    },
    formatTag: function(tag) {
        if(tag in this.TAGS)
            return this.TAGS[tag];
        return tag;
    },
};



export function hashObjectDeep(obj: object, hash0?: unknown) {
    let hash = hash0;
    if(!hash0)
        hash = sha1.create();

    if(Array.isArray(obj)) {
        hash.update('[');
        for(let i = 0; i < obj.length; i++) {
            const val = obj[i];
            hashObjectDeep(val, hash);
            hash.update('\0');
        }
        hash.update(']');
    } else if(typeof (obj) == 'object') {
        const keys = Object.keys(obj);
        keys.sort();
        hash.update('{');
        for(let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const val = obj[key];
            hash.update(JSON.stringify(key));
            hash.update(':');
            if(val !== undefined) {
                hashObjectDeep(val, hash);
            }
            hash.update('\0');
        }
        hash.update('}');
    } else {
        hash.update(JSON.stringify(obj));
    }

    if(!hash0)
        return hash.hex();
    return '';
}



interface RowCountCacheType {
    rowCount: number;
    lastFilterHash: string | null;
    beforeSelect: (query: unknonw) => void;
    afterSelect: (table: unknonw) => void;
}

type RowCountCacheConstructorType = new() => RowCountCacheType;

function RowCountCache(this:RowCountCacheType) {
}
RowCountCache.prototype = {
    rowCount: -1,
    lastFilterHash: null,
    /**
    * @type Function
    */
    beforeSelect: function(query) {
        const thisFilterHash = hashObjectDeep({ table: query.table.name || query.table, query: query.filter || query.table.filter || {} });
        if(thisFilterHash != this.lastFilterHash) {
            this.lastFilterHash = thisFilterHash;
            this.rowCount = -1;
        }
        if(this.rowCount >= 0) {
            if(!query.options)
                query.options = {};
            query.options.row_count_style = 'none';
        }
    },
    /**
    * @type Function
    */
    afterSelect: function(table) {
        if(this.rowCount >= 0) {
            table.rowCount = this.rowCount;
        } else {
            this.rowCount = table.rowCount;
        }
    },
};
const _RowCountCache = RowCountCache as RowCountCacheConstructorType;
export { _RowCountCache as RowCountCache };



export function AsyncQueue(timeout) {
    const queue = [];
    let current = null;
    function execNext() {
        if(!queue.length) {
            current = null;
            return;
        }
        current = queue.shift();
        setTimeout(exec, timeout ? 100 : 1);
    }
    function exec() {
        try {
            current(execNext);
        } catch(err) {
            errutil.box(null, err);
            execNext();
        }
    }
    this.push = function(fn) {
        queue.push(fn);
        if(!current)
            execNext();
    };
    this.parallel = function() {
        const functions = $.makeArray(arguments);
        return function() {
            const args = $.makeArray(arguments);
            args.unshift(this);
            for(let i = 0; i < functions.length; i++) {
                const fn = functions[i].bind.apply(functions[i], args);
                setTimeout(() => fn(), 1);
            }
        };
    };
}



export function addInputmask(elements) {
    // quantity opts
    // "2_2_1_5_Quantita": { decimal: {positive: true, fractional: true, integer: [1,12], fract: [2,8]} },
    const opts = {
        mask: '*{*}',
        autoUnmask: true,
        onBeforeMask: function(value) {
            //remove mask if value is masked
            if(value.indexOf(',') >= 0)
                value = prettyNums2(value, false);
            value = prettyNums2(value, true);
            return value;
        },
        onUnMask: function(masked, unmasked) {
            return prettyNums2(masked, false);
        },
        onBeforeWrite: function(event, buffer, caretPos, opts0) {
            let rslt = null;
            if(event && (event.type == 'blur')) {
                const masked = opts0.onBeforeMask(buffer.join('')).split('');
                rslt = {
                    caret: caretPos,
                    buffer: masked,
                    refreshFromBuffer: true,
                };
            }
            if(this.el)
                $(this.el).removeAttr('data-unmasked-cache');
            return rslt;
        },
        definitions: {
            '*': {
                validator: function(chrs, maskset, pos, strict, opts0) {
                    return true;
                },
            },
        },
    };
    $(elements).filter(':not(.inputmask-lite), :not(.inputmask-currency)').inputmask(opts);

    // lite opts
    const liteOpts = $.extend({}, opts);
    $(elements).filter('.inputmask-lite').inputmask(liteOpts);

    // currency opts
    // "2_1_1_6_2_ImportoBollo": { required: requireRelativiAlBollo, decimal: {fractional: true, integer: [1,11], fract: 2} },
    const currencyOpts = $.extend({}, opts);
    $(elements).filter('.inputmask-currency').inputmask(currencyOpts);
}


export function getQueryParams() {
    return $.url().param();
}
export function multiSelectHelp() {
    const $inputs = $('.dataTable .table-selector');
    let total = $inputs.filter(':checked').length; //this will be 0 if none are found

    $inputs.on('click touch', function(event) {
        const toggle = !event.shiftKey;
        if(!CHECKBOX_MULTISELECT) {
            if($(this).is(':checked') && toggle) {
                total++;
                if(total == 10) {
                    $(this).parent().find('.company-data__select_help').slideToggle()
                        .delay(5000)
                        .fadeOut();
                    total = 1;
                }
            } else {
                total = 0;
            }
        }
    });
}


export function resizeIframe(obj) {
    try {
        //result frame "Salvataggio in corso" is completelly hidden
        let height = obj.contentWindow.document.body.scrollHeight;
        if($(obj).is(':hidden') && (Number(height) < 100))
            height = 100;
        obj.style.height = height + 'px';
    } catch(e) { /**/ }
}


// new JSON format data for qr
export function generateNewJsonFromOld(oldJson) {
    const newJson = {
        'anag': {
            'naz': 'IT',
            'cf': '',
            'piva': '',
            'denom': '',
            'domFisc': {
                'prov': '',
                'cap': '',
                'com': '',
                'ind': '',
                'naz': 'IT',
            },
        },
        'dtGenQr': getNewJsonDate(),
        'SDI': {
            'cod': '',
            'pec': '',
        },
        'ext': {
            'numero_tel': '',
            'email': '',
            'targa': '',
            'conducente': '',
        },
    };
    if(!oldJson) return newJson;
    if(typeof oldJson == 'string') oldJson = JSON.parse(oldJson);
    Object.keys(oldJson).forEach(function(key) {
        switch(key) {
            case 'CAP':
                newJson.anag.domFisc.cap = oldJson[key];
                break;
            case 'CodiceDestinatarioExtended':
                newJson.SDI.cod = oldJson[key];
                break;
            case 'CodiceFiscale':
                newJson.anag.cf = oldJson[key];
                break;
            case 'Comune':
                newJson.anag.domFisc.com = oldJson[key];
                break;
            case 'Denominazione':
                newJson.anag.denom = oldJson[key];
                break;
            case 'IdCodice':
                newJson.anag.piva = oldJson[key];
                break;
            case 'Indirizzo':
                newJson.anag.domFisc.ind = oldJson[key];
                break;
            case 'Provincia':
                newJson.anag.domFisc.prov = oldJson[key];
                break;
            case 'cellulare':
                newJson.ext.numero_tel = oldJson[key];
                break;
            case 'email':
                newJson.ext.email = oldJson[key];
                newJson.SDI.pec = oldJson[key];
                break;
            case 'targa':
                newJson.ext.targa = oldJson[key];
                break;
            case 'conducente':
                newJson.ext.conducente = oldJson[key];
                break;
        }
    });
    return newJson;
}
export function generateOldJsonFromNew(newJson) {
    if(!newJson) return {};
    if(typeof newJson == 'string') newJson = JSON.parse(newJson);
    let oldJson;
    try {
        oldJson = {
            'CAP': newJson.anag?.domFisc?.cap,
            'CodiceDestinatarioExtended': newJson.SDI?.cod,
            'CodiceFiscale': newJson.anag?.cf,
            'Comune': newJson.anag?.domFisc?.com,
            'Denominazione': newJson.anag?.denom,
            'IdCodice': newJson.anag?.piva,
            'Indirizzo': newJson.anag?.domFisc?.ind,
            'Provincia': newJson.anag?.domFisc?.prov,
            'cellulare': newJson.ext?.numero_tel,
            'email': (newJson.SDI?.pec) || (newJson.ext?.email),
            'targa': newJson.ext?.targa,
            'conducente': newJson.ext?.conducente,
        };
    } catch(e) { /**/ }
    return oldJson;
}
export function detectNewJsonData(obj) {
    if(!obj) return false;
    if(typeof obj == 'string') obj = JSON.parse(obj);
    let state = false;
    Object.keys(obj).forEach(function(key) {
        if(/anag|dtGenQr|SDI|ext/.test(key)) {
            state = true;
        }
    });
    return state;
}
export function getNewJsonDate() {
    const date1 = new Date();
    // "2018-06-04T17:35:30.038+0200
    return '' + date1.toISOString() + getProperTimezone(date1);

    function setProperZeros(val) {
        if(val < 10 && val > -10) {
            if(val < 0) return String(val).replace('-', '-0');
            return '0' + val;
        } return val;
    }
    function getProperTimezone(date) {
        const val = String(date.getTimezoneOffset() / 60).split('.');
        if(val.length <= 1) return (setProperZeros(+val[0]) + '00');

        const hours = setProperZeros(+val[0]);
        const minutes = setProperZeros(+val[1]);
        return (hours + minutes);
    }
}

//all exports in one place to make linter happy
//maybe some time it will become module export
export const _commons = {
    DISPLAY_WIDTHS: DISPLAY_WIDTHS,
    setMultiSelect,
    getMultiSelect,
    waiting: waiting,
    errutil: errutil,
    ajaxWaiting: ajaxWaiting,
    crypt: crypt,
    dbs: dbs,
    century: century,
    handler2: handler2,
    getRadioState: getRadioState,
    bindExclusiveControl: bindExclusiveControl,
    bindExclusive: bindExclusive,
    bindExclusives: bindExclusives,
    executeValidationRules: executeValidationRules,
    prepareCustomValidationMethods: prepareCustomValidationMethods,
    checkAnyFilledGroup: checkAnyFilledGroup,
    setupAutoprettifyControls: setupAutoprettifyControls,
    setupAutofillControls: setupAutofillControls,
    setupAutofillControl: setupAutofillControl,
    bindCustomSelect: bindCustomSelect,
    makeFullScreenControlHeight: makeFullScreenControlHeight,
    timeformat: timeformat,
    tablerender: tablerender,
    tabledata: tabledata,
    InitDataTablesCustomFeatures: InitDataTablesCustomFeatures,
    FileImporterCommon: FileImporterCommon,
    FilterManagerCommon: FilterManagerCommon,
    hexToBase64: hexToBase64,
    base64ToHex: base64ToHex,
    xmlescape: xmlescape,
    xmlunescapeLite: xmlunescapeLite,
    unknownPaginator: unknownPaginator,
    AdvancedPeriodManager: AdvancedPeriodManager,
    ColVisCustomInit: ColVisCustomInit,
    prettyNums2: prettyNums2,
    isInternalDocumentType: isInternalDocumentType,
    TagProcessorCommon: TagProcessorCommon,
    hashObjectDeep: hashObjectDeep,
    RowCountCache: RowCountCache,
    AsyncQueue: AsyncQueue,
    addInputmask: addInputmask,
    getQueryParams: getQueryParams,
    multiSelectHelp: multiSelectHelp,
};
